
export class States {
    static state = {
      'US': [
        {
          name: 'AK-Alaska',
          abbreviation: 'AK',
        },
        {
          name: 'AL-Alabama',
          abbreviation: 'AL',
        },
        {
          name: 'AR-Arkansas',
          abbreviation: 'AR',
        },
        {
          name: 'AZ-Arizona',
          abbreviation: 'AZ',
        },
        {
          name: 'CA-California',
          abbreviation: 'CA',
        },
        {
          name: 'CO-Colorado',
          abbreviation: 'CO',
        },
        {
          name: 'CT-Connecticut',
          abbreviation: 'CT',
        },
        {
          name: 'DC-District Of Columbia',
          abbreviation: 'DC',
        },
        {
          name: 'DE-Delaware',
          abbreviation: 'DE',
        },
        {
          name: 'FL-Florida',
          abbreviation: 'FL',
        },
        {
          name: 'GA-Georgia',
          abbreviation: 'GA',
        },
        {
          name: 'HI-Hawaii',
          abbreviation: 'HI',
        },
        {
          name: 'IA-Iowa',
          abbreviation: 'IA',
        },
        {
          name: 'ID-Idaho',
          abbreviation: 'ID',
        },
        {
          name: 'IL-Illinois',
          abbreviation: 'IL',
        },
        {
          name: 'IN-Indiana',
          abbreviation: 'IN',
        },
        {
          name: 'KS-Kansas',
          abbreviation: 'KS',
        },
        {
          name: 'KY-Kentucky',
          abbreviation: 'KY',
        },
        {
          name: 'LA-Louisiana',
          abbreviation: 'LA',
        },
        {
          name: 'MA-Massachusetts',
          abbreviation: 'MA',
        },
        {
          name: 'MD-Maryland',
          abbreviation: 'MD',
        },
        {
          name: 'ME-Maine',
          abbreviation: 'ME',
        },
        {
          name: 'MI-Michigan',
          abbreviation: 'MI',
        },
        {
          name: 'MN-Minnesota',
          abbreviation: 'MN',
        },
        {
          name: 'MO-Missouri',
          abbreviation: 'MO',
        },
        {
          name: 'MS-Mississippi',
          abbreviation: 'MS',
        },
        {
          name: 'MT-Montana',
          abbreviation: 'MT',
        },
        {
          name: 'NC-North Carolina',
          abbreviation: 'NC',
        },
        {
          name: 'ND-North Dakota',
          abbreviation: 'ND',
        },
        {
          name: 'NE-Nebraska',
          abbreviation: 'NE',
        },
        {
          name: 'NH-New Hampshire',
          abbreviation: 'NH',
        },
        {
          name: 'NJ-New Jersey',
          abbreviation: 'NJ',
        },
        {
          name: 'NM-New Mexico',
          abbreviation: 'NM',
        },
        {
          name: 'NV-Nevada',
          abbreviation: 'NV',
        },
        {
          name: 'NY-New York',
          abbreviation: 'NY',
        },
        {
          name: 'OH-Ohio',
          abbreviation: 'OH',
        },
        {
          name: 'OK-Oklahoma',
          abbreviation: 'OK',
        },
        {
          name: 'OR-Oregon',
          abbreviation: 'OR',
        },
        {
          name: 'PA-Pennsylvania',
          abbreviation: 'PA',
        },
        {
          name: 'RI-Rhode Island',
          abbreviation: 'RI',
        },
        {
          name: 'SC-South Carolina',
          abbreviation: 'SC',
        },
        {
          name: 'SD-South Dakota',
          abbreviation: 'SD',
        },
        {
          name: 'TN-Tennessee',
          abbreviation: 'TN',
        },
        {
          name: 'TX-Texas',
          abbreviation: 'TX',
        },
        {
          name: 'UT-Utah',
          abbreviation: 'UT',
        },
        {
          name: 'VA-Virginia',
          abbreviation: 'VA',
        },
        {
          name: 'VT-Vermont',
          abbreviation: 'VT',
        },
        {
          name: 'WA-Washington',
          abbreviation: 'WA',
        },
        {
          name: 'WI-Wisconsin',
          abbreviation: 'WI',
        },
        {
          name: 'WV-West Virginia',
          abbreviation: 'WV',
        },
        {
          name: 'WY-Wyoming',
          abbreviation: 'WY',
        },
      ],
      'CA': [
        {
          name: 'AB-Alberta',
          abbreviation: 'AB',
        },
        {
          name: 'BC-British Columbia',
          abbreviation: 'BC',
        },
        {
          name: 'MB-Manitoba',
          abbreviation: 'MB',
        },
        {
          name: 'NB-New Brunswick',
          abbreviation: 'NB',
        },
        {
          name: 'NL-Newfoundland and Labrador',
          abbreviation: 'NL',
        },
        {
          name: 'NS-Nova Scotia',
          abbreviation: 'NS',
        },
        {
          name: 'NT-Northwest Territories',
          abbreviation: 'NT',
        },
        {
          name: 'NU-Nunavut',
          abbreviation: 'NU',
        },
        {
          name: 'ON-Ontario',
          abbreviation: 'ON',
        },
        {
          name: 'PE-Prince Edward Island',
          abbreviation: 'PE',
        },
        {
          name: 'QC-Quebec',
          abbreviation: 'QC',
        },
        {
          name: 'SK-Saskatchewan',
          abbreviation: 'SK',
        },
        {
          name: 'YT-Yukon',
          abbreviation: 'YT',
        },
      ],
      'AF': [
        {
          name: 'EC-Eastern Cape',
          abbreviation: 'EC',
        },
        {
          name: 'FS-Free State',
          abbreviation: 'FS',
        },
        {
          name: 'GT-Gauteng',
          abbreviation: 'GT',
        },
        {
          name: 'LP-Limpopo',
          abbreviation: 'LP',
        },
        {
          name: 'MP-Mpumalanga',
          abbreviation: 'MP',
        },
        {
          name: 'NC-Northern Cape',
          abbreviation: 'NC',
        },
        {
          name: 'NL-KwaZulu Natal',
          abbreviation: 'NL',
        },
        {
          name: 'NW-North West',
          abbreviation: 'NW',
        },
        {
          name: 'WC-Western Cape',
          abbreviation: 'WC',
        },
      ],
      '4': [
        {
          name: 'CA-Zambezi',
          abbreviation: 'CA',
        },
        {
          name: 'ER-Erongo',
          abbreviation: 'ER',
        },
        {
          name: 'HA-Hardap',
          abbreviation: 'HA',
        },
        {
          name: 'KA-Karas',
          abbreviation: 'KA',
        },
        {
          name: 'KE-Kavango East',
          abbreviation: 'KE',
        },
        {
          name: 'KH-Khomas',
          abbreviation: 'KH',
        },
        {
          name: 'KU-Kunene',
          abbreviation: 'KU',
        },
        {
          name: 'KW-Kavango West',
          abbreviation: 'KW',
        },
        {
          name: 'OD-Otjozondjupa',
          abbreviation: 'OD',
        },
        {
          name: 'OH-Omaheke',
          abbreviation: 'OH',
        },
        {
          name: 'ON-Oshana',
          abbreviation: 'ON',
        },
        {
          name: 'OS-Omusati',
          abbreviation: 'OS',
        },
        {
          name: 'OT-Oshikoto',
          abbreviation: 'OT',
        },
        {
          name: 'OW-Ohangwena',
          abbreviation: 'OW',
        },
      ],
      'NZ': [
        {
          name: 'AUK-Auckland',
          abbreviation: 'AUK',
        },
        {
          name: 'BOP-Bay Of Plenty',
          abbreviation: 'BOP',
        },
        {
          name: 'CAN-Canterbury',
          abbreviation: 'CAN',
        },
        {
          name: 'GIS-Gisborne',
          abbreviation: 'GIS',
        },
        {
          name: 'HKB-Hawke"s Bay',
          abbreviation: 'HKB',
        },
        {
          name: 'MBH-Marlborough',
          abbreviation: 'MBH',
        },
        {
          name: 'MWT-Manawatu Wanganui',
          abbreviation: 'MWT',
        },
        {
          name: 'NSN-Nelson',
          abbreviation: 'NSN',
        },
        {
          name: 'NTL-Northland',
          abbreviation: 'NTL',
        },
        {
          name: 'OTA-Otago',
          abbreviation: 'OTA',
        },
        {
          name: 'STL-Southland',
          abbreviation: 'STL',
        },
        {
          name: 'STL-Southland',
          abbreviation: 'STL',
        },
        {
          name: 'TAS-Tasman',
          abbreviation: 'TAS',
        },
        {
          name: 'TKI-Taranaki',
          abbreviation: 'TKI',
        },
        {
          name: 'WGN-Wellington',
          abbreviation: 'WGN',
        },
        {
          name: 'WKO-Waikato',
          abbreviation: 'WKO',
        },
        {
          name: 'WTC-West Coast',
          abbreviation: 'WTC',
        },
      ],
    };
  }
  